var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutBase",
    [
      _vm.suspendSuccess
        ? _c("div", { staticClass: "alert alert--success" }, [
            _vm._v("User has been suspended"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.unsuspendSuccess
        ? _c("div", { staticClass: "alert alert--success" }, [
            _vm._v("User has been unsuspended"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "header",
        { attrs: { id: "content__header" } },
        [
          _vm.currentUser
            ? [
                _c("h1", [_vm._v("My Account")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.logout.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Logout")]
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn--primary",
                    attrs: {
                      to: {
                        name: "view-user",
                        params: { user_id: _vm.user.id },
                      },
                    },
                  },
                  [_vm._v("\n\t\t\t\tView Profile\n\t\t\t")]
                ),
              ]
            : [
                _c("h1", [_vm._v("Edit User")]),
                _vm._v(" "),
                _vm.suspended
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn--danger",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showUnsuspendModal.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t\tUnsuspend user\n\t\t\t")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn--danger",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showSuspendModal.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Suspend user")]
                    ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn--primary",
                    attrs: {
                      to: { name: "view-user", params: { user_id: _vm.id } },
                    },
                  },
                  [_vm._v("\n\t\t\t\tView Profile\n\t\t\t")]
                ),
                _vm._v(" "),
                _vm.savedFormData.can && _vm.savedFormData.can.delete
                  ? _c("button", { staticClass: "btn" }, [
                      _vm._v("Delete User"),
                    ])
                  : _vm._e(),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "vue-tabs",
        { ref: "tabs", on: { "tab-change": _vm.onTabChange } },
        [
          _c(
            "v-tab",
            { attrs: { id: "profile", title: "Personal Information" } },
            [
              _c("UserFormProfile", {
                attrs: { currentUser: _vm.currentUser },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "password", title: "Change Password" } },
            [
              _c("UserFormPassword", {
                attrs: { currentUser: _vm.currentUser },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "following", title: "Sectors you follow" } },
            [
              _c("UserFormFollowedSectors", {
                attrs: { currentUser: _vm.currentUser },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { id: "expertise", title: "Sector Expertise" } },
            [
              _c("UserFormSpecialisedSectors", {
                attrs: { currentUser: _vm.currentUser },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }